export default {
  emptyMessage: "Add products to your enquiry by clicking on the + icon.",
  enquireNow: "Enquire now",
  enquireNowMessage: "After enquiring a venture architect will be in touch to book time to walk you through the above services.",
  thankYouContactText:
    "Someone from our venture solutions team will review your enquiry and book a time with you in the next 24 hours to discuss how we can work to support you. Looking forward to chatting and supporting you with your venture.",
  thankYouText: "Thank you for your enquiry.",
  yourEnquiry: "Your Enquiry",
};
